import { POLICY_STATE_REASON } from "consts";

import { isValidDateObject } from "./format-date";

const TWENTY_DAYS_UTC = 1728000000;

export const acceptPaymentOnCancelledPolicy = (
  policyStatus,
  cancellationReason,
  renewalDate,
  minimumPaymentDue,
  isUnderMoratorium
) => {
  if (isUnderMoratorium) {
    return false;
  }

  const isCancelledPolicy = RegExp(/(^cancel)/gi).test(policyStatus);
  const ISOpattern = /^\d\d\d\d-\d\d-\d\d/;

  let renewalDateTimestamp;

  if (typeof renewalDate == "string" && ISOpattern.test(renewalDate)) {
    renewalDateTimestamp = Date.parse(renewalDate);
  } else if (isValidDateObject(renewalDate)) {
    renewalDateTimestamp = renewalDate.getTime();
  } else {
    renewalDateTimestamp = Date.now();
  }

  const isWithin20DaysOfRenewalAlt = (renewalDateTimestamp) => {
    return Date.now() - renewalDateTimestamp <= TWENTY_DAYS_UTC;
  };

  const renewalWasNotAccepted =
    cancellationReason === POLICY_STATE_REASON.renewalNotAccepted;

  return (
    isCancelledPolicy &&
    renewalWasNotAccepted &&
    isWithin20DaysOfRenewalAlt(renewalDateTimestamp) &&
    minimumPaymentDue > 0
  );
};
